import { render, staticRenderFns } from "./RatingStarIcon.vue?vue&type=template&id=91c7d2e6&scoped=true"
import script from "./RatingStarIcon.vue?vue&type=script&lang=js"
export * from "./RatingStarIcon.vue?vue&type=script&lang=js"
import style0 from "./RatingStarIcon.vue?vue&type=style&index=0&id=91c7d2e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91c7d2e6",
  null
  
)

export default component.exports